import angular from 'angular';
import uiRouter from 'angular-ui-router';
import dateFormElementComponent from './dateFormElement.component';

let dateFormElementModule = angular.module('dateFormElement', [
  uiRouter
])

.component('dateFormElement', dateFormElementComponent)

.name;

export default dateFormElementModule;
